var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-wrap" },
    [
      _c(
        "div",
        { staticClass: "ms-login" },
        [
          _c("div", { staticClass: "ms-title" }, [_vm._v("SP-SRM")]),
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "ms-content",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "0px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "userCd" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: { placeholder: "邀请码" },
                      model: {
                        value: _vm.ruleForm.userCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "userCd", $$v)
                        },
                        expression: "ruleForm.userCd",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "prepend", icon: "fa fa-user" },
                        slot: "prepend",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "login-btn" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("登录")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showLoginAgreementDialog,
            "append-to-body": "",
            "close-on-click-modal": false,
            showClose: false,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showLoginAgreementDialog = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c("center", [
                    _c("h2", [_vm._v("麦当劳中国供应商关系管理系统登录声明")]),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "div",
                { staticClass: "handle-box" },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 25 },
                            model: {
                              value: _vm.loginAgreementText,
                              callback: function ($$v) {
                                _vm.loginAgreementText = $$v
                              },
                              expression: "loginAgreementText",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.agreeFlag,
                        callback: function ($$v) {
                          _vm.agreeFlag = $$v
                        },
                        expression: "agreeFlag",
                      },
                    },
                    [_vm._v("已阅读并同意登录声明")]
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: !_vm.agreeFlag },
                      on: { click: _vm.agreeMethod },
                    },
                    [_vm._v("立即登陆")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }